import { ValidateSessionService } from "./validateSession.service";
import { api } from "../../apiProvider";

export const validateSessionAdapter: ValidateSessionService = async (params) => {
    const resp = await api.validateSession();
    return resp.data;
};
